import LOG from './log';

const KM_API = {
  km_record: properties => {
    const _kmq = '_kmq' in window ? window._kmq : []; // eslint-disable-line
    LOG('[KM_API]', properties);
    return _kmq.push(['record', properties.km_event, properties.km_property]);
  },
  km_identify: properties => {
    const _kmq = '_kmq' in window ? window._kmq : []; // eslint-disable-line
    LOG('[KM_API]', properties);
    return _kmq.push(['identify', properties.km_property.email]);
  },
  km_reset: properties => {
    const _kmq = '_kmq' in window ? window._kmq : []; // eslint-disable-line
    LOG('[KM_API]', properties);
    return _kmq.push(['clearIdentity']);
  }
};

export const analytics = properties => {
  const dl = window.dataLayer || [];
  if (properties.event in KM_API) {
    return KM_API[properties.event](properties);
  }
  dl.push(properties);
  LOG('[analytics]', properties);
  return dl;
};

const removeFalsy = metricsObject => {
  const newObj = {};
  Object.keys(metricsObject).forEach(prop => {
    if (metricsObject[prop]) {
      newObj[prop] = metricsObject[prop];
    }
  });
  return newObj;
};

export const getURL = () =>
  window.location.href.replace(/(http(s)?:\/\/)/g, '');

export const filterProperties = (data = {}, filter = true) => {
  const info = {
    email: data.email || '',
    nome: data.nome || '',
    'tipo usuario': data.userType || 'nao identificado',
    'tipo assinatura': data.subscriptionType || 'nao possui',
    dispositivo: data.dispositivo || '',
    plataforma: data.plataforma || '',
    origem: data.origem || '',
    campanha: data.campaign || '',
    content: data.content || '',
    meio: data.meio || '',
    produto: 'degustacao',
    editoria: data.editoria || '',
    subeditoria: data.subeditoria || '',
    url: getURL(),
    'url materia': data.url || '',
    'ID materia': data.idMateria || '',
    'ID Oferta': data.offerId || '',
    modalidade: data.modality || '',
    'tipo login': data.loginType || ''
  };

  return filter ? removeFalsy(info) : info;
};

export const sendMetricsEvent = data => {
  const { eventName, pageview } = data;
  const url = getURL();

  // Send Pageview Virtual to GA only if pageview is true and nossaCookie is active (user signed in)
  if (pageview) {
    analytics({
      event: 'PageViewVirtual',
      eventPageurl: url,
      eventPageTitle: eventName
    });
    LOG('DEBUG_GA', '| Sending pageview', `| Title => ${eventName}`, url);
  }

  // Send custom event to kissmetrics
  // analytics({
  //   event: 'km_record',
  //   km_event: eventName,
  //   km_property: {
  //     ...filterProperties(
  //       {
  //         ...metricsProperties
  //       },
  //       filter
  //     ),
  //     ...{ 'url materia': metricsProperties.url }
  //   }
  // });

  // LOG(
  //   'DEBUG_KM',
  //   `| Sending ${pageview ? 'pageview' : 'custom event'}`,
  //   `| km_record`,
  //   `| Event => ${eventName}`,
  //   url
  // );
};

export default { analytics, filterProperties };
